import * as Sentry from '@sentry/react';
import Utils from 'src/utils';
import store from 'src/store';
import { selectUserInfo } from 'src/store/selectors/userInfo';
import { isEmpty } from 'ramda';
import packageJson from '../../package.json';
function getIdpInfo() {
    const data = {};
    try {
        const idpUser = Utils.accessToken.getParsedAccessToken();
        if (idpUser) {
            data.company_id = idpUser.caCompanyId;
            data.email = idpUser.email;
        }
    }
    catch (err) {
        console.error(err);
    }
    return data;
}
function getUserInfo() {
    const data = {};
    try {
        const userInfo = selectUserInfo(store.getState());
        if (!isEmpty(userInfo)) {
            data.user_id = userInfo.UserId;
            data.user_name = userInfo.UserName;
            data.company_id = userInfo.CompanyId;
            data.company_name = userInfo.CompanyName;
        }
    }
    catch (err) {
        console.error(err);
    }
    return data;
}
function initialize() {
    if (process.env.NODE_ENV !== 'production')
        return;
    Sentry.init({
        dsn: 'https://fa14103c7b296eec157adeca71dcecb6@o268970.ingest.us.sentry.io/4508692100743168',
        release: `ca_web@${packageJson.version}`,
        integrations: [Sentry.browserTracingIntegration()],
        beforeSend: async (event) => {
            if (event.extra) {
                event.extra.idpInfo = getIdpInfo();
                event.extra.userInfo = getUserInfo();
            }
            return event;
        },
        tracesSampleRate: 0.2
    });
}
initialize();
